import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative py-20 md:py-28 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20warm%20toned%20gradient%20with%20flowing%20curves%20in%20terracotta%20and%20cream%2C%20minimalist%20artistic%20background%2C%20soft%20texture%2C%20modern%20elegant%20aesthetic%2C%20no%20text%2C%20warm%20ambient%20feel%2C%20premium%20creative%20agency%20backdrop&width=1800&height=600&seq=cta-bg-tangxin&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-primary-900/80"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-background-50 mb-4">
          准备好让品牌内容创造增长了吗？
        </h2>
        <p className="text-background-50/70 text-sm md:text-base max-w-xl mx-auto mb-8 leading-relaxed">
          与糖心传媒一起，为您的品牌打造专属的内容营销策略，让每一次内容触达都成为增长的机会
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/about"
            className="bg-background-50 hover:bg-background-100 text-primary-600 px-8 py-3.5 rounded-full text-sm font-semibold transition-all hover:scale-105 whitespace-nowrap"
          >
            立即咨询合作
          </Link>
          <Link
            to="/category/all"
            className="flex items-center gap-2 text-background-50/80 hover:text-background-50 text-sm font-medium transition-colors whitespace-nowrap"
          >
            <span>了解更多</span>
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}